import { render } from "./Participants.vue?vue&type=template&id=6d55cd3b&ts=true"
import script from "./Participants.vue?vue&type=script&lang=ts"
export * from "./Participants.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__